import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Adminnavbar from "../Adminnavbar";

export default function CreateBlog() {
  const [loader, setLoader] = useState(false);
  const [photoPreviewUrl, setPhotoPreviewUrl] = useState(null);

  const [blog, setBlog] = useState({
    title: "",
    description: "",
    photo: null,
  });

  const navigate = useNavigate();

  /* ================= TEXT INPUT ================= */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBlog({ ...blog, [name]: value });
  };

  /* ================= IMAGE INPUT ================= */
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // Validate image type
    if (!file.type.startsWith("image/")) {
      Swal.fire("Invalid File", "Please select an image file", "warning");
      e.target.value = "";
      return;
    }

    // ✅ Validate image size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10 MB

    if (file.size > maxSize) {
      Swal.fire(
        "File Too Large",
        "Image size must be less than 10 MB",
        "warning"
      );
      e.target.value = "";
      return;
    }

    setBlog({ ...blog, photo: file });
    setPhotoPreviewUrl(URL.createObjectURL(file));
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    // VALIDATION
    if (!blog.title.trim()) {
      Swal.fire("Validation Error", "Title is required", "warning");
      return;
    }

    if (!blog.description.trim()) {
      Swal.fire("Validation Error", "Description is required", "warning");
      return;
    }

    if (!blog.photo) {
      Swal.fire("Validation Error", "Image is mandatory", "warning");
      return;
    }

    setLoader(true);

    try {
      const formData = new FormData();
      formData.append("title", blog.title);
      formData.append("description", blog.description);
      formData.append("photo", blog.photo);

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/blog/store`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Knowledge Center Inserted Successfully",
          timer: 1500,
        }).then(() => navigate("/knowledge-center-list"));
      } else {
        Swal.fire("Error", "Knowledge Center insert failed", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <Adminnavbar />

      <div className="page-wrapper">
        <div className="content">
          <form onSubmit={handleSubmit}>
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admindashbord">Dashboard</Link> /
                </li>
                <li className="breadcrumb-item">
                  <Link to="/knowledge-center-list">Knowledge Center</Link> /
                </li>
                <li className="breadcrumb-item active">Add Knowledge Center</li>
              </ol>
            </nav>

            <div className="content-page-header">
              <h5>Add Knowledge Center</h5>
            </div>

            <div className="row">
              {/* TITLE */}
              <div className="col-lg-4">
                <div className="form-group">
                  <label>Title *</label>
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    value={blog.title}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {/* DESCRIPTION */}
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Description *</label>
                  <textarea
                    name="description"
                    className="form-control"
                    rows="4"
                    value={blog.description}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {/* IMAGE */}
              <div className="col-lg-4 mt-3">
                <div className="form-group">
                  <label>Upload Image *</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={handleFileChange}
                  />
                  <small className="text-muted">
                    Max image size: 10 MB
                  </small>
                </div>
              </div>

              {/* IMAGE PREVIEW */}
              {photoPreviewUrl && (
                <div className="col-lg-6 mt-3">
                  <img
                    src={photoPreviewUrl}
                    alt="Preview"
                    style={{
                      width: "100%",
                      maxHeight: "300px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                    }}
                  />
                </div>
              )}

              {/* BUTTONS */}
              <div className="col-lg-12 mt-4">
                <div className="btn-path">
                  <Link to="/knowledge-center-list" className="btn btn-cancel me-3">
                    Back
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-submit"
                    disabled={loader}
                  >
                    {loader ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
